import React from "react";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import MarketingPageHero from "@/components/marketing/MarketingPageHero";
import { usePageMeta } from "@/lib/usePageMeta";
import Roadmap from "@/components/landing/Roadmap";

export default function RoadmapPage() {
  usePageMeta(
    "Roadmap — Leadmato",
    "See what's shipped, what's in progress, and what we're building next on the Leadmato roadmap.",
  );
  return (
    <MarketingLayout>
      <MarketingPageHero
        eyebrow="Roadmap"
        title="What we're building next."
        subtitle="Public commitments, honest timelines. Ship dates move — priorities don't."
      />
      <Roadmap />
    </MarketingLayout>
  );
}
